import { addressTransform, normalizedAddressTransform } from '@/utils/tracking/address'

const BANNER_BOTTOM_ID = 'resultPageAdBottom'
const BANNER_MIDDLE_ID = 'resultPageAdMiddle'

export const adsConfigSlotReady = (addresses) => {
  const addressGroups = {
    addresses: [],
    normalized_addresses: [],
  }

  addresses?.forEach((address) => {
    addressGroups.addresses.push(addressTransform(address))
    addressGroups.normalized_addresses.push(normalizedAddressTransform(address))
  })

  return {
    ad: {
      bottom_result_page: BANNER_BOTTOM_ID,
      in_between_result_page: BANNER_MIDDLE_ID,
      ...addressGroups,
    },
    event: 'resultPageAdSlotReady',
    _clear: true,
  }
}

export const adElementIds = [BANNER_BOTTOM_ID, BANNER_MIDDLE_ID]
